// https://github.com/mui-org/material-ui/tree/v1-beta/examples/create-react-app
import React from 'react'
import PropTypes from 'prop-types'

import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline'
import basicTheme from 'basicTheme'

const customizeTheme = (colors = {}, assets = []) => {
  const customized = { ...basicTheme }

  if (colors.brand) {
    customized.palette.secondary.main = colors.brand
  }

  customized.colors = {
    ...customized.colors,
    ...colors,
  }

  let customizedImages = {
    arrowLeft: `
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path d="M14.6,20 L7,12.4 C6.8,12.2 6.8,11.8 7,11.6 L14.6,4 C14.8,3.8 15.2,3.8 15.4,4 L16,4.6 C16.2,4.8 16.2,5.2 16,5.4 L9.8,11.6 C9.6,11.8 9.6,12.2 9.8,12.4 L16,18.6 C16.2,18.8 16.2,19.2 16,19.4 L15.4,20 C15.2,20.2 14.8,20.2 14.6,20 Z" id="Path" fill-rule="nonzero"></path>
  </svg>
`,
    arrowRight: `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M8.6,20 L8,19.4 C7.8,19.2 7.8,18.8 8,18.6 L14.2,12.4 C14.4,12.2 14.4,11.8 14.2,11.6 L8,5.4 C7.8,5.2 7.8,4.8 8,4.6 L8.6,4 C8.8,3.8 9.2,3.8 9.4,4 L17,11.6 C17.2,11.8 17.2,12.2 17,12.4 L9.4,20 C9.2,20.2 8.8,20.2 8.6,20 Z" id="Path" fill-rule="nonzero"></path>
    </svg>
  `,
  }
  for (const asset of assets) {
    customizedImages = {
      ...customizedImages,
      [asset.name]: asset.url,
    }
  }
  customized.images = customizedImages

  return customized
}

export const computeDeviceSize = (width) => {
  const { breakpoints } = basicTheme
  let deviceSize = null

  /**
   * Start with the slowest value as low end devices often have a small screen.
   *
   * innerWidth |xs      sm      md      md-lg   lg      xl
   *            |-------|-------|-------|-------|-------|------>
   * deviceSize |  xs   |  sm   |  md   | md-lg |  lg   |  xl
   */
  let index = 1
  while (deviceSize === null && index < breakpoints.keys.length) {
    const currentWidth = breakpoints.keys[index]

    // @media are inclusive, so reproduce the behavior here.
    if (width < breakpoints.values[currentWidth]) {
      deviceSize = breakpoints.keys[index - 1]
      break
    }

    index += 1
  }

  return deviceSize || 'xl'
}

const ThemeProvider = ({ colors, assets, children }) => (
  <MuiThemeProvider theme={customizeTheme(colors, assets)}>
    <CssBaseline />
    {children}
  </MuiThemeProvider>
)

ThemeProvider.propTypes = {
  colors: PropTypes.shape({}),
  assets: PropTypes.arrayOf(PropTypes.shape({})),
  children: PropTypes.shape({}),
}

ThemeProvider.defaultProps = {
  colors: {},
  assets: [],
  children: null,
}

export default ThemeProvider
